import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: 'onClick'
        }
    }

    onClick() {
        this.call('show', null, 'Share')
    }
}
